import React, { useState, useEffect } from "react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Menu, X } from "lucide-react";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white shadow-md py-2 md:py-3" : "bg-white/95 backdrop-blur-sm py-4 md:py-5"}`}>
      <div className="container mx-auto px-6 flex items-center justify-between">
        {}
        <Link to="/" className="flex items-center">
          <img src="https://current-narwhal.10web.cloud/wp-content/uploads/2026/04/Untitled-design-8.png" alt="Atlas Surgical Partners" className="h-8 md:h-12" />
        </Link>

        {}
<div className="hidden md:flex items-center space-x-8">          <NavigationMenu viewport={false}>
            <NavigationMenuList className="flex-col md:flex-row gap-4 md:gap-6">
              {!loading && menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                  <NavigationMenuLink asChild>
                    <Link to={item.href || "#"} className="text-foreground font-medium hover:text-secondary transition-colors">
                      {item.label}
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>)}
            </NavigationMenuList>
          </NavigationMenu>
          
          <Link to="/facilities/" className="bg-linear-to-r from-[#1E4FA3] to-[#0A2E6E] text-white px-6 py-2.5 rounded-lg font-semibold hover:opacity-90 transition-all shadow-sm">
            Request Coverage
          </Link>
        </div>

        {}
        <button className="md:hidden text-foreground p-2 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-muted absolute top-full left-0 w-full shadow-xl animate-in fade-in slide-in-from-top-5">
          <div className="flex flex-col p-6 space-y-4">
            {!loading && menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-foreground text-lg font-medium border-b border-muted pb-2" onClick={() => setIsMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
            <Link to="#" className="bg-linear-to-r from-[#1E4FA3] to-[#0A2E6E] text-white px-6 py-3 rounded-lg font-semibold text-center shadow-md mt-4" onClick={() => setIsMobileMenuOpen(false)}>
              Request Coverage
            </Link>
          </div>
        </div>}
    </header>;
}
export default function Header() {
  return <MenuProvider menu_id="16" className="w-full">
      <HeaderContent />
    </MenuProvider>;
}